import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { archiveRow, syncActions } from '../../../../actions/dictionary-values';
import { createDataGridRows } from '../../../../reducers/state/dictionary-values';
import { commonEnums } from '@codametrix/ui-common';
import './archive-modal.scss';
import { isResourceViewOnly } from '../../../../core/resources';
import { ModalComponent } from '../../../../components/Modal/modal';
import { Divider, Flex, Text } from '@chakra-ui/react';
import { DataGrid } from '../../../../components/data-grid/data-grid';
import { Button } from '../../../../components/button/button';
import LoadingOverlay from '../../../../components/loader-overlay/loader-overlay';
import { CustomDictionaryValueHeader } from '../custom-dictionary-value-list-header';
import { jiraTicketRegex } from '../../dictionary-utils';
import { InputVariant } from '../../../../core/enums';
import Input from '../../../../components/input/input';
import { styles } from './archive-modal.styles';
import { Box } from '@chakra-ui/react';
import theme from '../../../../theme';
const { ResourceId } = commonEnums;
const shimTenantColumn = (rows, tenants)=>{
    const dataGridRows = createDataGridRows(rows);
    return rows.map((row, index)=>{
        const tenantMatch = tenants.find((tenant)=>tenant.key === row.tenantId.uuid);
        return {
            ...dataGridRows[index],
            organizationCode: tenantMatch?.organizationCode
        };
    });
};
const updatedColDefs = (columnDefs)=>{
    const cols = columnDefs.map((col)=>{
        let column = {
            ...col,
            headerName: col.displayName,
            field: col.key
        };
        return column;
    });
    return cols;
};
export const ArchiveModal = ()=>{
    const dispatch = useDispatch();
    const classes = styles();
    const { archiveModal: { potentialArchives, selectedRow, loadState, archiveResult }, sortablePageable, selectedDictionary, columnDefs } = useSelector((state)=>state.dictionaryValues);
    const tenants = useSelector((state)=>state.dictionaryTenants.sortablePageable.pageableDefinition.content);
    const viewOnly = useSelector((state)=>isResourceViewOnly(state.ui.context.activeContext?.resources || [], ResourceId.DICTIONARY));
    const handleJiraTicketInputChange = (input)=>{
        setJiraTicket(input.target.value);
        if (jiraTicketRegex.test(input.target.value) && !viewOnly) {
            setArchiveButtonDisabled(false);
            if (potentialArchives.length !== 0) {
                setArchiveChildrenButtonDisabled(false);
            } else {
                setArchiveChildrenButtonDisabled(true);
            }
        } else {
            setArchiveButtonDisabled(true);
        }
    };
    const gridRows = shimTenantColumn([
        selectedRow
    ], tenants);
    const potentialArchiveGridRows = shimTenantColumn(potentialArchives, tenants);
    const archiveResultGridRows = shimTenantColumn(archiveResult, tenants);
    const defaultColumnKeys = [
        'effectiveDate',
        'endDate',
        'remove'
    ];
    const [colDefs, setColDefs] = useState([]);
    const [jiraTicket, setJiraTicket] = useState('');
    const [archiveButtonDisabled, setArchiveButtonDisabled] = useState(true);
    const [archiveChildrenButtonDisabled, setArchiveChildrenButtonDisabled] = useState(potentialArchives.length === 0 || viewOnly);
    const submitArchive = (archiveChildren)=>{
        const payload = {
            archiveChildren,
            row: selectedRow,
            dictionary: selectedDictionary,
            sortablePageable: sortablePageable,
            jiraTicket: jiraTicket
        };
        dispatch(archiveRow(payload));
    };
    const closeArchiveModal = ()=>{
        dispatch(syncActions.toggleArchiveModal(false));
    };
    const inFlight = loadState.loading;
    const tenatIsCodametrix = selectedRow.tenantId.uuid === 'BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C';
    const showPotentialArchives = !tenatIsCodametrix && potentialArchives.length > 0;
    useEffect(()=>{
        if (columnDefs?.length) {
            const colDefsWithTenant = [
                ...columnDefs,
                {
                    key: 'organizationCode',
                    displayName: 'Organization'
                }
            ].filter((colDef)=>!defaultColumnKeys.includes(colDef.key));
            const coldefs = updatedColDefs(colDefsWithTenant);
            setColDefs(coldefs);
        }
    // eslint-disable-next-line
    }, [
        columnDefs
    ]);
    return /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        isOpen: true,
        handleClose: closeArchiveModal,
        showCloseIcon: true,
        modalHeader: /*#__PURE__*/ _jsx(Text, {
            children: "Archive Row"
        }),
        width: '80rem',
        modalContent: /*#__PURE__*/ _jsx("div", {
            style: {
                padding: '16px'
            },
            children: !inFlight ? /*#__PURE__*/ _jsx("div", {
                children: !archiveResult.length ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            style: {
                                paddingBottom: '8px'
                            },
                            children: "You have chosen to archive row."
                        }),
                        ' ',
                        /*#__PURE__*/ _jsxs(Box, {
                            paddingTop: theme.space[12],
                            flex: "1 1 0",
                            minHeight: 0,
                            display: "flex",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ _jsx(DataGrid, {
                                    columnDefs: colDefs,
                                    rowData: gridRows,
                                    customHeader: CustomDictionaryValueHeader
                                }),
                                " "
                            ]
                        }),
                        ' ',
                        showPotentialArchives ? /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx(Divider, {}),
                                potentialArchives.length > 1 ? /*#__PURE__*/ _jsxs(Text, {
                                    style: {
                                        paddingBottom: '8px'
                                    },
                                    children: [
                                        "There are ",
                                        potentialArchives.length,
                                        " matching rows for dictionary ",
                                        /*#__PURE__*/ _jsx("b", {
                                            children: selectedRow.dictionaryName
                                        }),
                                        " in the following child organizations.",
                                        ' '
                                    ]
                                }) : /*#__PURE__*/ _jsxs(Text, {
                                    style: {
                                        paddingBottom: '8px'
                                    },
                                    children: [
                                        "There is a matching row for dictionary",
                                        ' ',
                                        /*#__PURE__*/ _jsx("b", {
                                            children: selectedRow.dictionaryName
                                        }),
                                        " in a child organization.",
                                        ' '
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    paddingTop: theme.space[12],
                                    flex: "1 1 0",
                                    minHeight: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    children: /*#__PURE__*/ _jsx(DataGrid, {
                                        columnDefs: colDefs,
                                        rowData: potentialArchiveGridRows,
                                        customHeader: CustomDictionaryValueHeader
                                    })
                                })
                            ]
                        }) : null
                    ]
                }) : /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            children: "The following rows have been archived"
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            paddingTop: theme.space[12],
                            flex: "1 1 0",
                            minHeight: 0,
                            display: "flex",
                            flexDirection: "column",
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                columnDefs: colDefs,
                                rowData: archiveResultGridRows,
                                customHeader: CustomDictionaryValueHeader
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ _jsx(Flex, {
                height: '250px',
                children: /*#__PURE__*/ _jsx(LoadingOverlay, {})
            })
        }),
        modalFooter: /*#__PURE__*/ _jsx("div", {
            children: !inFlight && !archiveResult.length ? /*#__PURE__*/ _jsxs(Flex, {
                sx: classes.footer,
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        autoFocus: true,
                        placeholder: 'Jira Ticket #',
                        variant: InputVariant.TEXT,
                        label: '',
                        onChange: handleJiraTicketInputChange,
                        dataTestId: 'jiraTicketInput'
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        label: 'Archive Row',
                        name: 'Archive Row',
                        dataTestId: 'Archive Row',
                        onClick: ()=>submitArchive(false),
                        disabled: archiveButtonDisabled,
                        sx: classes.archiveButton
                    }),
                    !tenatIsCodametrix ? /*#__PURE__*/ _jsx(Button, {
                        disabled: archiveChildrenButtonDisabled,
                        onClick: ()=>submitArchive(true),
                        label: 'Archive with children',
                        name: 'Archive with children',
                        dataTestId: 'Archive with children',
                        sx: classes.archiveButton
                    }) : null
                ]
            }) : null
        })
    });
};
